import styled from "@emotion/styled";

export const InlinePlayerContainer = styled.div``;
